import Api from "./axios";

// HPD Violations APIs
export const getHPDViolations = async (params = {}) => {
  const { page = 1, pageSize = 10, search = "", buildingId = "", clientId = "", status = "" } = params;
  return await Api.get(
    `/v1/violation?page=${page}&page_size=${pageSize}&search=${search}${buildingId ? `&building_id=${buildingId}` : ""}${clientId ? `&client_id=${clientId}` : ""}${status ? `&status=${status}` : ""}`
  );
};

// Get violation Codes
export const getViolationCodes = async () => {
  return await Api.get(`/v1/violation/code`);
};

export const getHPDViolationById = async (id) => {
  return await Api.get(`/v1/violation/${id}`);
};

export const updateHPDViolation = async (id, data) => {
  return await Api.put(`/v1/violation/${id}`, data);
};

export const createHPDViolation = async (data) => {
  return await Api.post(`/v1/violation/manual`, data);
};

// HPD Tickets APIs
export const getHPDTickets = async (params = {}) => {
  const { page = 1, pageSize = 10, search = "", buildingId = "", clientId = "", status = "" } = params;
  return await Api.get(
    `/v1/violation/tickets?page=${page}&page_size=${pageSize}&search=${search}${
      buildingId ? `&building_id=${buildingId}` : ""
    }${clientId ? `&client_id=${clientId}` : ""}${
      status ? `&status=${status}` : ""
    }`
  );
};

export const getHPDTicketById = async (id) => {
  return await Api.get(`/v1/violation/ticket/${id}`);
};

export const updateHPDTicket = async (id, data) => {
  return await Api.put(`/v1/violation/tickets/${id}`, data);
};

export const createHPDTicket = async (data) => {
  return await Api.post(`/v1/violation/manual`, data);
};


// HPD Document Upload
export const uploadHPDDocument = async (data) => {
  return await Api.post(`/v1/violation/tickets/attachments`, data.data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteHPDDocument = async (id) => {
  return await Api.delete(`/v1/violation/attachments/${id}`);
};

export const getHPDViolationNotes = async (id) => {
  return await Api.get(`/v1/violation/tickets/${id}/notes`);
};

export const createHPDTicketNote = async (id, data) => {
  return await Api.post(`/v1/violation/tickets/${id}/notes`, data);
};

export const deleteHPDTicketNote = async (noteId) => {
  return await Api.delete(`/v1/violation/notes/${noteId}`);
};

export const getPendingHireRequests = async (params = {}) => {
  const { page = 1, pageSize = 10, search = ""} = params;
  return await Api.get(
    `/v1/violation/tickets/pending-hire?page=${page}&page_size=${pageSize}&search=${search || ''}`
  );
};

export const hireUsRequests = async (data) => {
  return await Api.post(`/v1/violation/hire`, data);
};

export const getAcceptHireRequests = async (params = {}) => {
  console.log(params);
  const { page = 1, pageSize = 100, search = ""} = params;
  return await Api.get(
    `/v1/violation/accept-hire?page=${page}&page_size=${pageSize}&search=${
      search || ""
    }`
  );
};

export const acceptHPDPendingTickets = async (data) => {
  return await Api.post(`/v1/violation/accept-hire`, data);
};

export const getHPDViolationAffidavits = async () => {
  return await Api.get(`/v1/affidavits`);
};

export const getHPDAffidavitCategories = async () => {
  return await Api.get(`/v1/affidavits/categories`);
};

export const createHPDAffidavit = async (data) => {
  return await Api.post(`/v1/affidavits`, data);
};

export const deleteHPDAffidavit = async (id) => {
  return await Api.delete(`/v1/affidavits/${id}`);
};